<template>
  <div class="content"
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}"
  >

    <div class="flex flex-wrap px-5 md:px-1 pt-4 overflow-hidden">

      <div class="mb-5 px-3 w-1/2 md:w-full">
        <div class="bg-white shadow-sm rounded-md px-6 py-4">
            <h2 class="text-xl leading-6 text-gray-900 font-semibold mb-2">
              Hi {{ adminInfo && adminInfo.first_name || ''}}!
            </h2>
            <p class="mt-1 sm:mb-0 text-sm text-gray-500 font-normal">
              Add more information about yourself & your organization in
              <router-link :to="{name: 'settingsAccount'}" class="txt-blue">Settings</router-link>
            </p>
        </div>
      </div>

      <div class="mb-5 px-3 w-1/2 md:w-full">
        <div class="bg-white shadow-sm rounded-md">
          <div class="px-6 py-4 flex relative">
            <img class="absolute" :src="require('../../assets/images/todo-list.svg')" alt="">
            <div class="ml-14">
              <h2 class="text-xl leading-6 text-gray-900 font-semibold mb-2">Harness your Website</h2>
              <p class="mt-1 sm:mb-0 text-sm text-gray-500 font-normal">
                <router-link :to="{name: 'settingsWebsiteCode'}" class="txt-blue">Click here</router-link>
                for instructions on Harnessing your Website
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap px-5 md:px-1 overflow-hidden">
      <div class="px-3 w-1/4 md:w-full lg:w-2/4">
        <!--        <button id="flatfile-button">Test Uploading</button>-->
        <div class="d-block d-block-oc d-block-overview donations-table px-6 py-4 shadow-sm rounded-md bg-white"
             :class="{'d-block-open': expandDonationsOverview}"
        >
          <h2>Donations</h2>
          <div class="welcome">
            <router-link to="/reports">Total Raised</router-link>
          </div>
          <div v-if="donationsState === 'ready'">
            <div class="total ">${{totalDonations | formatMoney}}</div>
            <h4 class="txt-blue">Recent</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>Last 7 Days</td>
                <td class="value">${{getDonationsAmount(false, intervals.days7ago)| formatMoney}}</td>
              </tr>
              <tr>
                <td>Last 30 Days</td>
                <td class="value">${{getDonationsAmount(false, intervals.days30ago) | formatMoney}}</td>
              </tr>
              <tr>
                <td>Last 12 Months</td>
                <td class="value">${{getDonationsAmount(false, intervals.months12ago) | formatMoney}}</td>
              </tr>
              </tbody>
            </table>
            <h4 class="txt-blue">Last 3 Months</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>{{currentMonthName}}</td>
                <td class="value">${{getDonationsAmount(false, intervals.currentMonthStart) | formatMoney}}</td>
              </tr>
              <tr>
                <td>{{month1agoName}}</td>
                <td class="value">${{getDonationsAmount(intervals.month1AgoStart, intervals.currentMonthStart) |
                    formatMoney}}
                </td>
              </tr>
              <tr>
                <td>{{month2agoName}}</td>
                <td class="value">${{getDonationsAmount(intervals.month2AgoStart, intervals.month1AgoStart) |
                    formatMoney}}
                </td>
              </tr>
              </tbody>
            </table>
            <h4 class="txt-blue">Totals by Type</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>Round-Ups</td>
                <td class="value">${{roundUpsDonations | formatMoney}}</td>
              </tr>
              <tr>
                <td>One-Time</td>
                <td class="value">${{customDonations | formatMoney}}</td>
              </tr>
              <tr>
                <td>Monthly Avg</td>
                <td class="value">${{avgMonthlyDonation | formatMoney}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <a class="view-more view-more-activities"
             href="#"
             v-on:click.prevent="expandDonationsOverview = !expandDonationsOverview"
          >View <span class="show-more">More</span><span
              class="show-less">Less</span></a>
        </div>
      </div>
      <div class="px-3 w-1/4 md:w-full lg:w-2/4">
        <div class="d-block d-block-oc d-block-overview donors-totals px-6 py-4 shadow-sm rounded-md bg-white"
             :class="{'d-block-open': expandContactSummary}"
        >
          <h2>Contacts</h2>
          <div class="welcome">
            <router-link to="/contacts">Total Contacts</router-link>
          </div>
          <div v-if="donorsState === 'ready'">
            <div class="total">{{donors.length}}</div>
            <h4 class="txt-blue">Recent</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>Last 7 Days</td>
                <td class="value">{{donorsFormat(getDonorsCount(false, intervals.days7ago))}}</td>
              </tr>
              <tr>
                <td>Last 30 Days</td>
                <td class="value">{{donorsFormat(getDonorsCount(false, intervals.days30ago))}}</td>
              </tr>
              <tr>
                <td>Last 12 Months</td>
                <td class="value">{{donorsFormat(getDonorsCount(false, intervals.months12ago))}}</td>
              </tr>
              </tbody>
            </table>
            <h4 class="txt-blue">Last 3 Months</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>{{currentMonthName}}</td>
                <td class="value">{{donorsFormat(getDonorsCount(false, intervals.currentMonthStart))}}</td>
              </tr>
              <tr>
                <td>{{month1agoName}}</td>
                <td class="value">{{donorsFormat(getDonorsCount(intervals.month1AgoStart,
                    intervals.currentMonthStart))}}
                </td>
              </tr>
              <tr>
                <td>{{month2agoName}}</td>
                <td class="value">{{donorsFormat(getDonorsCount(intervals.month2AgoStart,
                    intervals.month1AgoStart))}}
                </td>
              </tr>
              </tbody>
            </table>
            <h4 class="txt-blue">Totals by Type</h4>
            <table class="table">
              <tbody>
              <tr>
                <td>Active Round-Ups</td>
                <td class="value">{{donorsCompleted}}</td>
              </tr>
              <tr>
                <td>Total Donors</td>
                <td class="value">{{donorsDonated}}</td>
              </tr>
              <tr>
                <td>Total Contacts</td>
                <td class="value">{{donors.length}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <a class="view-more view-more-activities"
             v-on:click.prevent="expandContactSummary = !expandContactSummary"
             href="#">View <span class="show-more">More</span><span
              class="show-less">Less</span></a>
        </div>

      </div>
      <div class="px-3 w-2/4 lg:w-full">
        <div class="d-block d-block-oc d-block-overview d-block-last-activities px-6 py-4 shadow-sm rounded-md bg-white"
             :class="{'d-block-open': expandActivities}"
        >
          <h2>Recent Activity</h2>
          <table class="table table-lg">
            <tbody class="last-activities-block">
            <tr
                v-for="(activity, index) in activities"
                :key="index"
            >
              <td><span :class="{
                      'txt-blue': activity.action === 'roundup' || activity.action === 'roundup_account_created',
                      'txt-orange': activity.action === 'custom',
                      'txt-green': activity.action === 'recurring' || activity.action === 'monthly_donation_created',
                      'txt-lightgray': activity.action === 'signup',
                    }"><span v-if="activity.action !== 'signup' && activity.action !== 'monthly_donation_created' && activity.amount">${{activity.amount/100 | formatMoney}}</span>
                    {{activity.action | activityTitle}}</span>
              </td>
              <td><span v-if="activity.donor && !activity.donor.is_guest"
                        class="show-donor-info"
                        v-on:click.prevent="showDonorSidebar(activity.donor.id)"
              >{{prepareDonorName(activity)}}</span><span v-else>{{prepareDonorName(activity)}}</span>
                <span v-if="activity.donor && activity.donor.is_guest" class="guest-pill">Guest</span>
              </td>
              <td class="text-right info">{{getTimeString(activity)}}</td>
            </tr>
            </tbody>
          </table>
          <a class="view-more view-more-activities"
             v-on:click.prevent="expandActivities = !expandActivities"
             href="#"
          >View <span class="show-more">More</span><span
              class="show-less">Less</span></a>
          <div v-if="activitiesLoaded && activities.length<1" class="empty-placeholder">
            <img :src="require('../../assets/paceholders/56.svg')" alt="No results">
            <h3>No Recent Activity Yet</h3>
          </div>
        </div>

      </div>
    </div>
    <div class="px-8 md:px-4 mb-2.5">
      <h3 class="text-xl font-semibold">Donation Pages</h3>
    </div>
    <div v-if="activeCharityInfo" class="flex flex-wrap px-5 md:px-1 overflow-hidden">
      <home-donor-info-card :href="baseDonorURL+'/donate'" title="Giving Form" subTitle="Default donation form"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorURL+'/donation/monthly'" title="Monthly Gifts" subTitle="Monthly by Default "></home-donor-info-card>
      <home-donor-info-card :href="baseDonorURL+'/donation/round-ups'" title="Round-Ups" subTitle="Round-Ups by Default"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/campaigns'" title="Campaigns" subTitle="View your Campaigns page"></home-donor-info-card>

      <home-donor-info-card :href="baseDonorNextURL+'/account/profile'" title="Donor Account" subTitle="View your Donor Account"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/events'" title="Events" subTitle="View your Events page"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/posts'" title="Posts" subTitle="View your Posts page"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/help-center'" title="Donor Support" subTitle="View your Donor Help Center"></home-donor-info-card>

      <home-donor-info-card :href="baseDonorNextURL+'/impact-amounts'" title="Impact Amounts" subTitle="View your Impact Amounts page"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/donation-calculator'" title="Donation Calculator" subTitle="View your Donation Calculator page"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/impact-calculator'" title="Impact Calculator" subTitle="View your Impact Calculator"></home-donor-info-card>
      <home-donor-info-card :href="baseDonorNextURL+'/giveup-giveback'" title="GiveUp to GiveBack" subTitle="View your GiveUp to GiveBack"></home-donor-info-card>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

  </div>
</template>

<script>
  import {
    getActivity,
  } from '@/utils/api';
  import {prepareDonorName} from '@/utils/donors';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import HomeDonorInfoCard from './home-donor-info-card.vue';
  import config from '../../../public/harness_config.json';
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Home',
    components: {
      DonorInfo,
      HomeDonorInfoCard
    },
    mounted() {
      this.updateActivities();
    },
    methods: {
      showDonorSidebar (donorId) {
        this.showDonorInfo = false;
        this.showDonorId = false;

        this.$nextTick(() => {
          this.showDonorInfo = true;
          this.showDonorId = donorId;
        });
      },
      donorsFormat(count) {
        return count ? '+' + count : 0;
      },
      getDonorsCount (start, end) {
        if (start && end) {
          return this.donors.reduce(
            (sum, v) => (moment(v.created_at) > start && moment(v.created_at) < end) ? sum + 1 : sum,
            0);
        }
        return this.donors.reduce((sum, v) => (moment(v.created_at) > end) ? sum + 1 : sum, 0);
      },
      getDonationsAmount (start, end) {
        if (start && end) {
          return this.donations.reduce(
            (sum, v) => (moment(v.created_at) > start && moment(v.created_at) < end) ? sum + v.amount * 1 : sum, 0) /
            100;
        }
        if (end) {
          return this.donations.reduce((sum, v) => (moment(v.created_at) > end) ? sum + v.amount * 1 : sum, 0) / 100;
        }
        return this.donations.reduce((sum, val) => sum + val.amount * 1, 0) / 100;
      },
      updateActivities() {
        if(this.activeCharityId) {
          getActivity(this.activeCharityId).then(res => {
            this.activities = res.slice(0, 11);
            this.activitiesLoaded = true;
          });
        }
      },
      getTimeString(activity) {
        const now = moment();
        const mom = moment(activity.date);
        return mom.from(now);
      },
      prepareDonorName (activity) {
        return prepareDonorName(activity.donor);
      },
    },
    watch: {
      'activeCharityId' () {
        this.activities = [];
        this.activitiesLoaded = false;

        this.updateActivities();
      },
    },
    computed: {
      ...mapState({
        donations: state => state.donations.donations,
        donationsState: state => state.donations.donationsState,
        donors: state => state.donors.donors,
        donorsState: state => state.donors.donorsState,
        activeCharityId: state => state.auth.activeCharityId,
        adminInfo: state => state.auth.adminInfo,

        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      config () {
        return config;
      },
      baseDonorNextURL() {
        return `${config.donor_next_scheme}://${this.activeCharityInfo.subdomain}.${config.donor_next_url}`
      },
      baseDonorURL() {
        return `${config.scheme}://${this.activeCharityInfo.subdomain}.${config.url}/wv2`
      },
      donorsCompleted () {
        return this.donors.reduce((sum, v) => v.status === 'complete' ? sum + 1 : sum, 0);
      },
      donorsDonated () {
        return this.donors.reduce((sum, v) => v.total > 0 ? sum + 1 : sum, 0);
      },
      totalDonations () {
        return this.donations.reduce((sum, val) => sum + val.amount * 1, 0) / 100;
      },
      roundUpsDonations () {
        return this.donations.reduce((sum, val) => val.type === 'roundup' ? sum + val.amount * 1 : sum, 0) / 100;
      },
      customDonations () {
        return this.donations.reduce((sum, val) => val.type === 'custom' ? sum + val.amount * 1 : sum, 0) / 100;
      },
      avgMonthlyDonation () {
        let minDate = this.donations.reduce((min, val) => min > moment(val.created_at) ? moment(val.created_at) : min,
          moment());

        minDate.startOf('month');

        let months = 0;
        for (let i = minDate; i < moment(); i.add(1, 'months')) {
          months++;
        }
        if (months < 1) {
          months = 1;
        }
        return this.totalDonations / months;
      },
    },
    data() {
      return {
        activities: [],
        activitiesLoaded: false,
        expandActivities: true,
        expandContactSummary: true,
        expandDonationsOverview: true,
        charitySubdomain: false,

        currentMonthName: moment().format('MMMM'),
        month1agoName: moment().subtract(1, 'months').format('MMMM'),
        month2agoName: moment().subtract(2, 'months').format('MMMM'),
        intervals: {
          days7ago: moment().subtract(7, 'days'),
          days30ago: moment().subtract(30, 'days'),
          months12ago: moment().subtract(12, 'months'),
          currentMonthStart: moment().startOf('month'),
          month1AgoStart: moment().subtract(1, 'months').startOf('month'),
          month2AgoStart: moment().subtract(2, 'months').startOf('month'),
        },
        showDonorInfo: false,
        showDonorId: null,
      };
    },
  };
</script>
<style scoped>
.d-block h2 {
  font-weight: 600;
}
.d-block .welcome {
  color: #237be6;
}
.d-block-overview .welcome a {
  float:none;
  font-size: 14px;
  font-weight: 600;
}
</style>

